import React, { FunctionComponent } from "react";

import UpArrow from "svg/upArrow";
import {
  Container,
  Header,
  Title,
  Icon,
  Email,
  Address,
  Logo,
  ScrollTop,
  Label,
  Button,
} from "./styled";

const Footer: FunctionComponent = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0 });
  };

  return (
    <Container id="contact">
      <Header>
        <Title>Contact Us</Title>
        <Icon />
      </Header>
      <Email>
        <Label>Email</Label>
        <a href="mailto:info@biom.studio">info@BIOM.STUDIO</a>
      </Email>
      <Address>
        <Label>Address</Label>
        <p>
          66 Gerrard Street East
          <br />
          Unit 305
          <br />
          M5B 2M2
          <br />
          Toronto
          <br />
          Canada
        </p>
      </Address>
      <Logo src="images/footer_logo.png" alt="logo" />
      <ScrollTop>
        <Label>Back to top</Label>
        <Button onClick={handleClick}>
          <UpArrow />
        </Button>
      </ScrollTop>
    </Container>
  );
};

export default Footer;
